export default (opts = {}) => {
  const component = {
    model: {
      
      defaults: {
        type:'link', 
        name:'Botão',
        traits: [
          {
            type:'id',
            name:'id',
            Label:'id',
          },
        ],
        components:[
          {
            type:'link',
            style: {
              'min-width': '250px',
              'font-size':'16px',
              'color': '#fff',
              'padding':'10px', 
              'border': 'none', 
              'border-radius': '5px', 
             'background-image': 'linear-gradient(#649dff 0%, #649dff 100%)',
              'text-align': 'center', 
              'display':'block',
              'text-decoration': 'none',
              'animation': 'pulse 1s infinite'
            },
            components: [
              {
                type:'text',
                content: 'Lorem Ipsum',
            },
            ],
          },
        ],
        styles: `
        *{
          font-family: Roboto, Arial, sans-serif;
        }
        @keyframes pulse {
          0% {
            transform: scale(0.98);
          }
        
          70% {
            transform: scale(1.05);
          }
        
          100% {
            transform: scale(0.98);
          }
        }
       `,
      },
    },
    view: {

    },
  };

  return component;
};
